module.exports = "/assets/data/e662ccfc95a7dc9f9f9e46d796f0d40f-SK16.data.json";